import React, { useRef, useEffect, useContext } from 'react';
import Slider from "react-slick";
import OneArticle from './OneArticle';
import OneConfession from './OneConfession';
import { CDN_URL, getInlineLoader } from '../Helpers';
import { AppContext } from '../App';

export default function BannerContainer({ url, nav }) {

	const appContext = useContext(AppContext);
	
	function view() {
		appContext.navTo(nav)
	}

	return (
		<div 
			style={{
				width: "100%",
				height: "auto",
				margin: "0",
				padding: "0",

			}}
			className='bg-surface'
			onClick={view}
		>
			<img
				src={CDN_URL+url}
				style={{
					width: '100%',
					height: 'auto',
				}}
			/>
		</div>
	);
}
